import { render, staticRenderFns } from "./WellbeingInitiatives.vue?vue&type=template&id=151c6804"
import script from "./WellbeingInitiatives.vue?vue&type=script&lang=js"
export * from "./WellbeingInitiatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports